export default __webpack_public_path__ + "static/media/face_1_28.e52b30c7.png";